export default __webpack_public_path__ + "static/media/July2016.5269e889.png";